import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogComponent } from '../../dialog.component';

@Component({
  selector: 'app-dialog-confirm-change-general-settings',
  templateUrl: './dialog-confirm-change-general-settings.component.html',
  styleUrls: ['./dialog-confirm-change-general-settings.component.scss']
})
export class DialogConfirmChangeGeneralSettingsComponent implements OnInit {

  public dialogOptions: any[] = [
    { id: '1', title: `Alterar configurações de todos os portais`},
    { id: '0', title: `Utilizar essa alteração como configuração padrão para todos os novos portais`}
  ];

  public formulario: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dateComponent: DialogComponent) {
  }

  ngOnInit() {
    this.formulario = this.formBuilder.group({
      cascade_change: [null, Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.formulario.controls; }

}
